import _get from 'lodash/get';
import {
  DocumentationFilterInputObject,
  FilterGroupingEnum,
} from 'graphql-common';
import { Values } from '@lib/interfaces/form';
import { FieldNames } from '../enums';

interface OptionItem {
  value: string;
  label: string;
  [key: string]: unknown;
}

export function createAdditionalFilters(
  filterValues: Values,
  isViewLocked = false,
): DocumentationFilterInputObject[] {
  const filters: DocumentationFilterInputObject[] = [];

  // sectorsId / sitesId / categoryName filter args are BE-gated by
  // `documentation_management` and trigger UPGRADE_PLAN_REQUIRED on a
  // plan-locked company. Skip them entirely when locked. `linkedAssetsId`
  // is allowed under the free-plan asset rule and stays.
  const sectors = _get(filterValues, FieldNames.Sectors, []) as OptionItem[];
  if (!isViewLocked && sectors && sectors.length > 0) {
    const sectorIds = sectors.map((sector) => sector.value);
    filters.push({
      sectorsId: {
        grouping: FilterGroupingEnum.And,
        predicate: { in: sectorIds },
        filterGroup: 'additionalFilters',
      },
    });
  }

  const sites = _get(filterValues, FieldNames.Sites, []) as OptionItem[];
  if (!isViewLocked && sites && sites.length > 0) {
    const siteIds = sites.map((site) => site.value);
    filters.push({
      sitesId: {
        grouping: FilterGroupingEnum.And,
        predicate: { in: siteIds },
        filterGroup: 'additionalFilters',
      },
    });
  }

  const equipment = _get(
    filterValues,
    FieldNames.Equipment,
    [],
  ) as OptionItem[];
  if (equipment && equipment.length > 0) {
    const assetIds = equipment.map((asset) => asset.value);
    filters.push({
      linkedAssetsId: {
        grouping: FilterGroupingEnum.And,
        predicate: { in: assetIds },
        filterGroup: 'additionalFilters',
      },
    });
  }

  const categories = _get(
    filterValues,
    FieldNames.Categories,
    [],
  ) as OptionItem[];
  if (!isViewLocked && categories && categories.length > 0) {
    const categoryNames = categories.map((cat) => cat.label);
    filters.push({
      categoryName: {
        grouping: FilterGroupingEnum.And,
        predicate: { in: categoryNames },
        filterGroup: 'additionalFilters',
      },
    });
  }

  return filters;
}
